export function getMapCardSizes() {
  if (typeof window !== 'undefined') {
    if (window.innerWidth > 1535) {
      return {
        list: 732,
        single: 500,
      }
    } else if (window.innerWidth > 1023) {
      return {
        list: 366,
        single: 400,
      }
    }
  }
  return {
    list: 0,
    single: 0,
  }
}
